var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtherTokensIconBanknote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 19,
    viewBox: "0 0 29 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_414_1093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1504 18.6736H0.849611C0.380002 18.6736 0 18.3 0 17.8383V1.13276C0 0.671078 0.380002 0.297485 0.849611 0.297485H28.1504C28.62 0.297485 29 0.671078 29 1.13276V17.8383C29 18.3 28.62 18.6736 28.1504 18.6736Z",
    fill: "url(#paint0_linear_414_1093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2967 15.3325H7.70288C7.23327 15.3325 6.85327 14.959 6.85327 14.4973C6.85327 13.1155 5.70992 11.9915 4.30445 11.9915C3.83483 11.9915 3.45483 11.6179 3.45483 11.1562V7.81507C3.45483 7.35338 3.83483 6.97979 4.30445 6.97979C5.70992 6.97979 6.85327 5.85573 6.85327 4.47395C6.85327 4.01227 7.23327 3.63867 7.70288 3.63867H21.2967C21.7662 3.63867 22.1462 4.01227 22.1462 4.47395C22.1462 5.85573 23.2896 6.97979 24.6951 6.97979C25.1647 6.97979 25.5447 7.35338 25.5447 7.81507V11.1562C25.5447 11.6179 25.1647 11.9915 24.6951 11.9915C23.2896 11.9915 22.1462 13.1155 22.1462 14.4973C22.1462 14.959 21.7662 15.3325 21.2967 15.3325Z",
    fill: "url(#paint1_linear_414_1093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11.9913C15.9077 11.9913 17.0489 10.8694 17.0489 9.48547C17.0489 8.10148 15.9077 6.97961 14.5 6.97961C13.0923 6.97961 11.9512 8.10148 11.9512 9.48547C11.9512 10.8694 13.0923 11.9913 14.5 11.9913Z",
    fill: "url(#paint2_linear_414_1093)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_414_1093",
    x1: -2.52714,
    y1: 6.45519,
    x2: 29.703,
    y2: 8.73502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1ADF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98A5F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_414_1093",
    x1: 14.4998,
    y1: 15.3326,
    x2: 14.4998,
    y2: 3.63867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_414_1093",
    x1: 11.507,
    y1: 8.65897,
    x2: 17.189,
    y2: 8.91805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1ADF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98A5F2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_414_1093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 19,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherTokensIconBanknote);
export default __webpack_public_path__ + "static/media/other-tokens-icon-banknote.28a52845c052d0fa424597e74d0f9f1d.svg";
export { ForwardRef as ReactComponent };